import React from 'react'
import { Helmet } from 'react-helmet'
import Layout from '../../components/web/Layout'
import HeroSlider from '../../components/web/home/HeroSlider'
import DepartmentsShowcase from '../../components/web/home/DepartmentsShowcase'
import TeamAndFAQ from './TeamAndFAQ'
import HistoryAboutSection from './HistoryAboutSection'
import PaymentOptions from '../../components/web/form/PaymentOptions'

function Home() {
  return (
    <Layout>
      <Helmet>
        <title>Association of Cine Television – Art, Costume & Production Designers | ACTADCD</title>
      </Helmet>
    <HeroSlider/>
    <DepartmentsShowcase/>
    <HistoryAboutSection/>
    <TeamAndFAQ/>
    </Layout>
  )
}

export default Home
